import RoutesMap from "../../route_control/RouteControl"
import { lazy } from "react"

import Main from "../../pages/landing_page/Main"
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'

const Login = lazy(() => import('../../pages/user/login/Login'))
const ParticipantSignUp = lazy(() => import('../../pages/user/sign_up/ParticipantSignUp'))
const OrganizerSignUp = lazy(() => import('../../pages/user/sign_up/OrganizerSignUp'))
const ForgotPassword = lazy(() => import('../../pages//user/forgot_password/ForgotPasssword'))
const EventList = lazy(() => import('../../pages/event/EventList'))
const EventDetails = lazy(() => import('../../pages/event/EventDetails'))
const AboutUs = lazy(() => import('../../pages/user/assets/AboutUs'))
const PrivacyPolicy = lazy(() => import('../../pages/user/assets/PrivacyPolicy'))
const RefundCancellation = lazy(() => import('../../pages/user/assets/RefundCancellation'))
const TermsConditions = lazy(() => import('../../pages/user/assets/TermsConditions'))
const ShippingDelivery = lazy(() => import('../../pages/user/assets/ShippingDelivery'))
const HelpSupport = lazy(() => import('../../pages/user/assets/HelpSupport'))

export const AuthRouteImport = {
    RoutesMap,
    Main,
    useNavigate,
    Swal,
    Login,
    ParticipantSignUp,
    OrganizerSignUp,
    ForgotPassword,
    EventList,
    EventDetails,
    AboutUs,
    PrivacyPolicy,
    RefundCancellation,
    TermsConditions,
    ShippingDelivery,
    HelpSupport,
}